import React from 'react'
import styled from 'styled-components';

const VisionBox = ({ header, content, borderColor, left }) => {
  return (
    !left ? (
      <div className='relative min-h-[300px] w-full'>
        <RightClip className={borderColor} />
        <RightBorderDiv className="borderdiv" />
        <div className='absolute top-[20%] w-[80%] flex flex-col justify-center px-5 py-4 items-stretch'>
          <p className='my-2 leading-[22px] text-[18px] font-bold'>{header}</p>
          <p className='my-2 leading-[22px] text-[18px]'>{content}</p>
        </div>
      </div>
    ) : (
      <div className='relative min-h-[300px] w-full'>
        <LeftClip className={borderColor} />
        <LeftBorderDiv className="borderdiv" />
        <div className='absolute top-[20%] left-[20%] w-[80%] flex flex-col justify-center px-5 py-4 items-stretch'>
          <p className='my-2 leading-[22px] text-[18px] font-bold'>{header}</p>
          <p className='my-2 leading-[22px] text-[18px]'>{content}</p>
        </div>
      </div>
    )
  )
}

export default VisionBox

const RightClip = styled.div`
  clip-path: polygon(0 0, 100% 0, 80% 100%, 0% 100%);
  min-height: 300px;
  min-width: 300px;
  display: flex;
`;

const RightBorderDiv = styled.div`
  position: absolute;
  background: #F2F2F2;
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
  top: 0;
  right: 0;
  clip-path: polygon(0 0, 96% 0, 76% 100%, 0 100%);
`;
const LeftClip = styled.div`
  clip-path: polygon(20% 0, 100% 0, 100% 100%, 0% 100%);
  min-height: 300px;
  min-width: 300px;
  display: flex;
`;

const LeftBorderDiv = styled.div`
  position: absolute;
  background: #F2F2F2;
  width: 100%;
  height: 100%;
  right: 0;
  bottom: 0;
  top: 0;
  right: 0;
  clip-path: polygon(24% 0, 100% 0, 100% 100%, 4% 100%);
`;